import Head from "next/head";
import Layout from "../components/3_organism/layout/layout";
import Styles from './extras/styles/teams.module.scss';
import { UserDataState } from '../global/state/global';
import { PleaseLogin } from '../components/1_atom/loginButton/loginButton';
import ClientOnly from '../components/0_global/clientOnly';
import { newAutomationModal } from '../global/constants/modals';
import { useModal, useTeams } from '../global/hooks';
import Button from '../components/1_atom/buttons/button';
import JoinTeamModal from '../components/2_molecule/modals/joinTeamModal';
import { iTeam } from 'typings';
import CreateTeamForm from '../components/2_molecule/modals/createTeamModal';
import Link from 'next/link';
import { useAtomValue } from 'jotai';

const Teams = () => {

  const [ triggerModal ] = useModal()
  const userData = useAtomValue(UserDataState)

  const Content = () => {
    const { teams, loadTeamsState } = useTeams()

    const JoinTeamButton = () => {
      return (
        <Button
          text="Join team"
          click={() => {
            const modal = newAutomationModal()
  
            modal.top = "Join a team"
            modal.middle = <JoinTeamModal />
            modal.bottom = "Done"
  
            triggerModal(modal)
          }}
        />
      )
    }

    const CreateTeamButton = () => {
      return (
        <Button
          text="Create team"
          variant="soft"
          color='white-on-dark'
          click={() => {
            const modal = newAutomationModal((input) => {
              console.log("callback", input)
            })

            modal.top = "Create new team"
            modal.middle = <CreateTeamForm mode="new" />

            triggerModal(modal)
          }}
        />
      )
    }
    
    const Team = ({ team }: { team: iTeam }) => {

      return (
        <Link href={{ pathname: "/team", query: { teamID: team.id } }}>
          <div className={`rounded bg2 p2`}>
            <div className="left-right-container">
              <h4 className="mb0">{team.teamName}</h4>
              <span>Members: {Object.keys(team.members)?.length}</span>
            </div>
          </div>
        </Link>
      )
    }

    const NoTeams = () => {
      return (
        <div className="flex-col center-center" style={{height: 350}}>
          <svg
            className="h-12 w-12 text-primary"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              vectorEffect="non-scaling-stroke"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
            />
          </svg>
          <h3 className="mt-2 text-sm font-medium">No teams</h3>
          <p className="mt-1 text-sm weak-text">Get started finding a team to join or creating your own.</p>
          <div className="flex-row gap2 mt2">
            <CreateTeamButton />
            <JoinTeamButton />
          </div>
        </div>
      )
    }

    const MyTeams = () => {

      return (
        <div className={Styles.teamsContainer}>
          {teams?.map((team) => {
            return <Team key={team.id} team={team} />
          })}
        </div>
      )
    }

    if(loadTeamsState === "loading") return <p>loading teams</p>
    if(teams?.length < 1 && loadTeamsState === "loaded") return <NoTeams />

    return (
      <div className="flex-col gap2">
        <div className="teams">
          <div className="left-right-container mb2">
            <h2 className="page-title">My teams</h2>
            <div className="flex-row gap1">
              <CreateTeamButton />
              <JoinTeamButton />
            </div>
          </div>
          <MyTeams />
        </div>
      </div>
    )
  }

  return (
    <Layout>
      <Head>
        <title>Prepi teams</title>
        <link rel="canonical" href="https://prepi.io" />
      </Head>
      <ClientOnly>
        {userData ? <Content /> : <PleaseLogin />}
      </ClientOnly>
    </Layout>
  );
}

export default Teams;